// Module
var code = "<i class=\"mm-step-icon-circle fal fa-circle\"></i> <span class=\"mm-step-icon-text\" ng-transclude></span> ";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Gui/Components/StepIcon/StepIcon.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;